"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaedecusArcaneBarrageAbilityHandler = exports.CaedecusArcaneBarrageActorAbilityFactory = exports.CaedecusArcaneBarrageAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class CaedecusArcaneBarrageAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.CaedecusArcaneBarrage;
        this.__typeName = "CaedecusArcaneBarrage";
    }
}
exports.CaedecusArcaneBarrageAbilityArgs = CaedecusArcaneBarrageAbilityArgs;
let CaedecusArcaneBarrageActorAbilityFactory = class CaedecusArcaneBarrageActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("CaedecusArcaneBarrage", "AllEnemies", 1);
    }
};
CaedecusArcaneBarrageActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("CaedecusArcaneBarrage")
], CaedecusArcaneBarrageActorAbilityFactory);
exports.CaedecusArcaneBarrageActorAbilityFactory = CaedecusArcaneBarrageActorAbilityFactory;
let CaedecusArcaneBarrageAbilityHandler = class CaedecusArcaneBarrageAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        const power = Math.round((0, Random_1.randomElement)([100, 120, 140]) / enemies.length);
        sequence = sequence.pushSequence("parallel");
        container.applyProjectileAttacksWithDamage({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            projectiles: enemies.map(targetId => ({
                targetId,
                path: "line",
                type: "PurpleArcaneMissle",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", power)
                ]
            })),
            onHit: (sequence, _attack, _damages, { targetId }) => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.DarknessEffectArgs(),
                });
            }
        });
    }
};
CaedecusArcaneBarrageAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.CaedecusArcaneBarrage)
], CaedecusArcaneBarrageAbilityHandler);
exports.CaedecusArcaneBarrageAbilityHandler = CaedecusArcaneBarrageAbilityHandler;
